var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Icon } from "../UI";
import React, { useEffect, useState } from 'react';









const Collapsible = ({ header, children, className, headerInfo, collapse }) => {
  const [collapsed, setCollapsed] = useState(collapse);
  useEffect(() => {
    setCollapsed(collapse);
  }, [collapse]);
  return /*#__PURE__*/(
    _jsx("div", { className: className }, void 0, /*#__PURE__*/
    _jsx("div", { className: "header", onClick: () => setCollapsed(!collapsed) }, void 0, /*#__PURE__*/
    _jsx("span", { className: "header-icon" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: collapsed ? 'caret-right' : 'caret-down' })), /*#__PURE__*/

    _jsx("span", {}, void 0, header),
    headerInfo && /*#__PURE__*/_jsx("span", { className: "header-info" }, void 0, headerInfo)),

    !collapsed && /*#__PURE__*/_jsx("div", { className: "content" }, void 0, children)));


};

export { Collapsible };